import axios from "../../../Shared/auth-header";
import AuthService from "../../../Auth/AuthService";
import React, { Component, Fragment } from "react";

import PermissionFeature from "../../../Permissions/PermissionFeature";
import moment from "moment";
import { OverlayTrigger, Popover } from "react-bootstrap";

import { toast } from "react-toastify";
export default {
  dateColumns: [
    "dateOfBirth",
    "plannedRetirementDate",
    "entryOnDutyDate",
    "serviceComputationDate",
    "bargainingUnitDate",
    "natcaBargainingUnitDate",
    "unionJoinedDate",
    "mandatoryRetirementDate",
    "retirementDate",
  ],
  boolColumns: [
    "hasLifeInsurance",
    "hasLongTermDisability",
    "isRetiredMilitaryController",
    "allowEmails",
    "allowPhoneCall",
    "allowPostalMail",
    "allowTextMessages",
    "allowFacebook",
    "isLocked",
    "isEnabled",
    "allowtext_legislative",
    "allowtext_newsalerts",
    "isActive",
    "isVerified",
  ],
  latLongColumn: ["latitude", "longitude"],
  phoneColumns: ["phoneNumber"],
  addressColumns: [
    "mailAddress",
    "deliveryAddress",
    "homeAddress",
    "physicalAddress",
    "primaryAddress",
  ],

  currencyColumns: [
    "yearlySalary",
    "hourlySalary",
    "drfDonation",
    "pacDonation",
    "ncfDonation",
    "expecteddues",
  ],

  emailColumns: ["emailAddress"],
};
